import { Tooltip, Fade, Button, Container, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import FilterListIcon from "@mui/icons-material/FilterList";
import "./FilterWidget.css";
import Sheet from "react-modal-sheet";
import Filter from "../Filter/Filter";
import Sort from "../Sort";

const FilterWidget = ({
	toggleFilterMenu,
	toggleSortMenu,
	showSort,
	showFilter,
	handleSort,
	sortValue,
}) => {
	return (
		<Container maxWidth="lg">
			<Box className="categorySettings">
				<Tooltip
					title="Ordenar"
					placement="bottom"
					TransitionComponent={Fade}
					TransitionProps={{ timeout: 600 }}
				>
					<Button
						color="secondary"
						startIcon={<SwapVertIcon />}
						onClick={toggleSortMenu}
					>
						<Typography
							sx={{
								fontSize: "0.8rem",
								textAlign: "left",
								textTransform: "uppercase",
							}}
							variant="body1"
						>
							Ordenar por
						</Typography>
					</Button>
				</Tooltip>
				<Tooltip
					title="Filtro"
					placement="bottom"
					TransitionComponent={Fade}
					TransitionProps={{ timeout: 600 }}
				>
					<Button
						color="secondary"
						startIcon={<FilterListIcon />}
						onClick={toggleFilterMenu}
					>
						<Typography
							sx={{
								fontSize: "0.8rem",
								textAlign: "left",
								textTransform: "uppercase",
							}}
							variant="body1"
						>
							Filtrar
						</Typography>
					</Button>
				</Tooltip>
			</Box>
			{showFilter && (
				<Sheet
					isOpen={showFilter}
					onClose={() => toggleFilterMenu()}
					snapPoints={[900, 700, 600, 400, 100, 0]}
					initialSnap={1}
				>
					<Sheet.Container>
						<Sheet.Header />
						<Sheet.Content>
							<Filter toggleFilterMenu={toggleFilterMenu} />
						</Sheet.Content>
					</Sheet.Container>
					<Sheet.Backdrop />
				</Sheet>
			)}

			{showSort && (
				<Sheet
					isOpen={showSort}
					onClose={() => toggleSortMenu()}
					snapPoints={[900, 700, 600, 400, 100, 0]}
					initialSnap={2}
				>
					<Sheet.Container>
						<Sheet.Header />
						<Sheet.Content>
							<Sort
								toggleSortMenu={toggleSortMenu}
								handleSort={handleSort}
								sortValue={sortValue}
							/>
						</Sheet.Content>
					</Sheet.Container>
					<Sheet.Backdrop />
				</Sheet>
			)}
		</Container>
	);
};

export default FilterWidget;
